<template>
  <div id="FiltrosDeBusqueda_div">
    <div id="encabezado-filtros" class="form-inline justify-content-between">
      <h5>{{tituloDeBusqueda}}</h5>
      <button v-if="accionCancelar != null || accionCancelar != undefined" class="btn-sm btn-primary" id="realizarFiltrosBusqueda_btn_cancelar" @click='accionCancelar.funcion'><i class="fas fa-window-close"></i></button>
    </div>
    <hr class="mt-2" />
    <!-- <div class="clearfix">      
      <div class="text-center">
        <button  class="btn btn-primary overwrapDeBotones float-left" @click="limpiarFiltros();ejecutalimpiarTablaResultados();"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Información</button>          
      </div> 
    </div>
    <hr class="mt-2" />  -->
    <div class="row">
    <div v-for="catalogo in catalogos" :key="catalogo.catalogoId" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4':'col-12']">     
      <div v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null">  
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales" id="PartidosJudiciales_div">
          <h6>Partido Judicial</h6>
          <C009PartidosJudiciales 
              :class="[parametros_PartidoJudicial.esInformativo ? 'catalogoInformativo' : '']" 
              v-on:valorParaElPadre="cambioDePartidoJudicialEvento" 
              v-on:valorParaElPadrePrimerElemento="cambioDePartidoJudicial"
              :prefijo="catalogo.etiquetaDeHtml" 
              :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect"
              :idDelInput="catalogo.idDelInput" 
              :parametros="parametros_PartidoJudicial.parametros" 
              :valorDefinido="parametros_PartidoJudicial.partidoJudicialId" 
              :key="parametros_PartidoJudicial.key">
          </C009PartidosJudiciales>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Juzgados && ((parametros_PartidoJudicial.partidoJudicialId > 0 || (area != undefined && area != null)) || AccionesMostrar.consulta)" id="Juzgados_div">
          <h6>Juzgado</h6>
          <C001Area 
            :class="[parametros_Area.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeAreaEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeArea"
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect"  
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Area.parametros" 
            :valorDefinido="parametros_Area.areaId" 
            :key="parametros_Area.key">
          </C001Area>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Materias" v-show="parametros_Area.areaId > 0  || ((area != undefined && area != null) || AccionesMostrar.consulta)" id="Materias_div">
          <h6>Materia</h6>
          <C002Materias 
            :class="[parametros_Materia.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeMateriaEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeMateria" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Materia.parametros" 
            :valorDefinido="parametros_Materia.materiaId" 
            :key="parametros_Materia.key">
          </C002Materias>
        </div>        
        <div v-if="!AccionesMostrar.administracion && mostrarDelito && catalogo.catalogoId == enumeraciones.catalogos.Delitos"  id="Delitos_div">
          <h6>Delitos</h6>
          <C008Delitos 
            :class="[parametros_Delito.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeDelitoEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeDelito" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Delito.parametros" 
            :valorDefinido="parametros_Delito.delitoId" 
            :key="parametros_Delito.key">
          </C008Delitos>
        </div>
        <div v-if="!AccionesMostrar.administracion && mostrarJuicio && catalogo.catalogoId == enumeraciones.catalogos.Juicios"  id="Juicios_div">
          <h6>Naturaleza</h6>
          <C042Juicios
            :class="[parametros_Juicio.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeJuicioEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeJuicio" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Juicio.parametros" 
            :mostrarseComoNaturaleza="true"
            :valorDefinido="parametros_Juicio.juicioId" 
            :key="parametros_Juicio.key">
          </C042Juicios>
        </div>
        <div v-if="mostrarTramite && catalogo.catalogoId == enumeraciones.catalogos.Tramites"  id="Tramites_div">
          <h6>Trámite</h6>
          <C046Tramites
            :class="[parametros_Tramite.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeTramiteEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeTramite" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Tramite.parametros"             
            :valorDefinido="parametros_Tramite.tramiteId" 
            :key="parametros_Tramite.key">
          </C046Tramites>
        </div>
        <div v-if="catalogo.catalogoId == enumeraciones.catalogos.TiposDeDocumentos && (parametros_Materia.materiaId > 0 || AccionesMostrar.consulta)" id="TiposDeDocumentos_div">
          <h6>Tipo de documento</h6>
          <C004TiposDocumento 
          :class="[parametros_TipoDocumento.esInformativo ? 'catalogoInformativo' : '']" 
          v-on:valorParaElPadre="cambioDeTipoDeDocumento" 
          :prefijo="catalogo.etiquetaDeHtml" 
          :tipo="catalogo.tipoDeSelect" 
          :idDelInput="catalogo.idDelInput" 
          :parametros="parametros_TipoDocumento.parametros" 
          :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" 
          :key="parametros_TipoDocumento.key"></C004TiposDocumento>
        </div>              
        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && (parametros_TipoDocumento.tipoDocumentoId > 0 || AccionesMostrar.consulta)" id="Consecutivo_div">
          <h6>Consecutivo</h6>
          <input class="form-control" type="text" placeholder="####/####" v-model="consecutivo" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeConsecutivo($event)" v-mask="'####/####'" />
        </div>
        <div class="form-group" v-if="mostrarNumeroExtra && catalogo.catalogoId == enumeraciones.catalogos.NumeroExtra && parametros_TipoDocumento.tipoDocumentoId > 0" id="NumeroExtra_div">
          <h6>Número</h6>
          <input class="form-control" type="text" placeholder="##" v-model="numeroExtra" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeNumeroExtra($event)" v-mask="'##'" />
        </div>        
        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.FechaDeInicio" id="FechaDeInicio_div">
          <h6 for="fechaDeInicio">Fecha inicial</h6>
          <input type="date" id="fechaDeInicio" v-model="fechaInicial" @change="A_Comun_FechaInicial(fechaInicial)" class="form-control" />
        </div>
        <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.FechaFinal" id="FechaFinal_div">
          <h6 for="fechaFinal">Fecha final</h6>
          <input type="date" id="fechaFinal" v-model="fechaFinal" @change="A_Comun_FechaFinal(fechaFinal)" class="form-control" />
        </div>
      </div>
    </div>
    
    <div v-if="esAreaDeEjecucion && (consecutivo && consecutivo.length == 9 ? parseInt(consecutivo.split('/')[1]) <= 2020 : true)" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4':'col-12']">
      <h6>Número romano</h6>
      <input type="text" id="numeroRomano" v-model="numeroRomano" class="form-control" v-mask="'AAA'" placeholder="III"/>
      <p>
        Nota: para la búsqueda de expedientes del Juzgado de ejecución de penas y medidas de seguridad anteriores a 2021 deberá escribir:<br/>
        I para los documentos provenientes del juzgado primero de ejecución<br/>
        II para los del juzgado segundo de ejecución<br/>
        III para los de la unidad de gestión
      </p>
    </div>   
    <div v-if="mostrarCampoNumCarpeta" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4':'col-12', 'form-group']">
      <h6>Número carpeta</h6>
      <input type="text" id="numeroCarpeta" v-model="numeroCarpeta" class="form-control" placeholder="#" v-mask="'#'"/>
    </div>
    <div class="col-12 form-group" v-if="(!AccionesMostrar.consulta && !AccionesMostrar.altaLaborales) && !consecutivo && baseDeDatosId != 3" id="anioConsecutivo_div">
      <h6>Año</h6>
      <input class="form-control" type="text" placeholder="####" v-model="anio" id="anioConsecutivo" v-mask="'####'" />
    </div>
    <div v-if="baseDeDatosId && baseDeDatosId == 3" id="FolioSentencia_div" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4':'col-12', 'form-group']">
        <h6>Folio de Acuerdo</h6>
        <input class="form-control" type="number" placeholder="####" v-model="folioAcuerdo" v-mask="'##################'"/>
    </div>
    </div>
    <hr v-if="!AccionesMostrar.altaLaborales && !AccionesMostrar.administracion" class="mt-2" />
    <div class="row">
      <div v-if="!AccionesMostrar.administracion && !AccionesMostrar.altaLaborales" id="TiposDeResoluciones_div" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4':'col-12']">
          <h6>Tipo de Resolucion</h6>
          <C003TiposResoluciones           
                class="mb-2"      
                v-on:valorParaElPadre="cambioDeTipoDeResolucion" 
                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                :idDelInput="'catalogoTiposResolucion'" 
                :parametros="parametros_TipoResolucion.parametros" 
                :valorDefinido="parametros_TipoResolucion.tipoResolucionId"
                :key="parametros_TipoResolucion.key"></C003TiposResoluciones>          
        </div>  
      <!-- <div v-if="(!AccionesMostrar.consulta && !AccionesMostrar.altaLaborales)" class="form-group" id="FolioSentencia_div" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4':'col-12']">
        <h6>Folio de Sentencia</h6>
        <input class="form-control" type="number" placeholder="####" v-model="folioSentencia" @change="cambioFolioSentencia($event)" v-mask="'##################'" />
      </div> -->       
      <div v-if="!AccionesMostrar.altaLaborales && !AccionesMostrar.administracion" id="fechaDeDictado_div" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-10 col-lg-8 col-xlg-8':'col-12']">
        <h6 for="fechaDeDictado">Fecha de dictado</h6>
        <div v-if="AccionesMostrar.administracion" class="form-group">
          <input type="date" id="fechaDeDictado" v-model="fechaDeDictado" @change="A_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado(fechaDeDictado)" class="form-control"/>
        </div>
        <div v-if="AccionesMostrar.consulta" class="row">
          <!-- <div v-bind:class="[AccionesMostrar.consulta ? 'form-group col-12 col-sm-6 col-md-6 col-lg-6 col-xlg-6':'form-group col-12 col-sm-6 col-md-6 col-lg-12 col-xlg-6']" v-if="AccionesMostrar.consulta" id="FechaDictadoDeInicio_div">
            <span for="fechaDictadoDeInicio" v-bind:style="{'display:inline !impotant;': AccionesMostrar.consulta}">Fecha inicial</span>
            <input type="date" id="fechaDictadoDeInicio" :max="fechaDeDictadoFinal" v-model="fechaDeDictadoInicial" class="form-control" v-bind:style="{'display:inline !impotant; width: 80%;': AccionesMostrar.consulta}"/>
          </div>
          <div v-bind:class="[AccionesMostrar.consulta ? 'form-group col-12 col-sm-6 col-md-6 col-lg-6 col-xlg-6':'form-group col-12 col-sm-6 col-md-6 col-lg-12 col-xlg-6']" v-if="AccionesMostrar.consulta" id="FechaDictadoFinal_div">
            <span for="fechaDictadoFinal" v-bind:style="{'display:inline;': AccionesMostrar.consulta}">Fecha final</span>
            <input type="date" id="fechaDictadoFinal" :min="fechaDeDictadoInicial" v-model="fechaDeDictadoFinal" class="form-control" v-bind:style="{'display:inline;': AccionesMostrar.consulta}"/>
          </div> -->

          <table id="tablaDeFechaDeDictadoInicio_table" v-bind:class="[AccionesMostrar.consulta ? 'form-group col-12 col-sm-8 col-md-6 col-lg-6 col-xlg-6':'form-group col-12 col-sm-6 col-md-6 col-lg-12 col-xlg-6']" v-if="AccionesMostrar.consulta">
            <tbody>
              <tr>
                <td class="text-left align-middle text-white text-nowrap" style="padding-left:15px;"><span for="fechaDictadoDeInicio">Fecha inicial: </span> </td>
                <td class="text-center align-middle" style="padding-right:15px;"><input type="date" id="fechaDictadoDeInicio" :max="fechaDeDictadoFinal" v-model="fechaDeDictadoInicial" class="form-control"/></td>
              </tr>
            </tbody>
          </table>
          <table id="tablaDeFechaDeDictadoFinal_table" v-bind:class="[AccionesMostrar.consulta ? 'form-group col-12 col-sm-8 col-md-6 col-lg-6 col-xlg-6':'form-group col-12 col-sm-6 col-md-6 col-lg-12 col-xlg-6']" v-if="AccionesMostrar.consulta">
            <tbody class="text-white">
              <tr>
                <td class="text-left align-middle text-white text-nowrap" style="padding-left:15px;"><span for="fechaDictadoFinal">Fecha final: </span></td>
                <td class="text-center align-middle" style="padding-right:15px;"><input type="date" id="fechaDictadoFinal" :min="fechaDeDictadoInicial" v-model="fechaDeDictadoFinal" class="form-control"/></td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
      <div v-if="AccionesMostrar.consulta && clasificacionYCaracteristicasPerspectivaDeGenero && clasificacionYCaracteristicasPerspectivaDeGenero.length > 0" id="PerspectivaDeGenero_div" v-bind:class="[AccionesMostrar.consulta ? 'col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12':'col-12']">
        <h6 style="display:inline-block" class="mr-2">Desea filtrar con perspectiva de género </h6>
        <!-- <i class="fas fa-chevron-left mr-4 ml-2" style="cursor:pointer" v-if="!mostrarFiltradoPerspectivaDeGenero" @click="mostrarFiltradoPerspectivaDeGenero = !mostrarFiltradoPerspectivaDeGenero"></i><i class="fas fa-chevron-down mr-4 ml-2" style="cursor:pointer" v-if="mostrarFiltradoPerspectivaDeGenero" @click="mostrarFiltradoPerspectivaDeGenero = !mostrarFiltradoPerspectivaDeGenero"></i> -->
        <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons" :key="togglePerspectivaRender">
            <label class="btn btn-secondary active" @click="mostrarFiltradoPerspectivaDeGenero=false, todasLasSentenciasMarcadasComoPerspectivaDeGenero=false">
                <input type="radio" name="options" id="radioSinFiltrar" autocomplete="off" checked> No
            </label>
            <label class="btn btn-secondary" v-tooltip:top="textoTodoPerspectivaDeGenero" @click="mostrarFiltradoPerspectivaDeGenero=false, todasLasSentenciasMarcadasComoPerspectivaDeGenero=true">
                <input type="radio" name="options" id="radioTodasLasSentencias" autocomplete="off"> Sí
            </label>
            <label class="btn btn-secondary" v-tooltip:top="textoFiltrarPerspectivaDeGenero" @click="mostrarFiltradoPerspectivaDeGenero=true, todasLasSentenciasMarcadasComoPerspectivaDeGenero=false">
                <input type="radio" name="options" id="radioFiltrar" autocomplete="off"> Filtros Específicos
            </label>
        </div>
        <div v-show="mostrarFiltradoPerspectivaDeGenero" class="row mx-0 border border-white p-2">
          <ul v-for="(clasificacion, indexClasificacion) in clasificacionYCaracteristicasPerspectivaDeGenero" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4 ml-0 pl-1" v-bind:key="indexClasificacion + clasificacion.SentenciaClasificacionPerspectivaDeGeneroId">
            <label v-show="mostrarFiltradoPerspectivaDeGenero" style="font-size: 0.9rem;">
              <input type="checkbox" id="perpectivaDeGenero_1" v-model="clasificacion.Activo" @change="limpiarSublistado(clasificacion, indexClasificacion)"> {{clasificacion.TipoClasificacionPerspectivaDeGenero.Nombre}}
            </label>
            <li>
              <ul v-show="mostrarFiltradoPerspectivaDeGenero && clasificacion.Activo">
                <li v-for="(caracteristica, index) in clasificacion.SentenciaCaracteristicasPerspectivaDeGenero" v-bind:key="index + caracteristica.SentenciaClasificacionPerspectivaDeGeneroId + caracteristica.CaracteristicaPerspectivaDeGeneroId_065DBPJ">
                  <label style="font-size: 0.8rem;" >
                    <input type="checkbox" id="perpectivaDeGenero_2" v-model="caracteristica.Activo"> {{caracteristica.CaracteristicaPerspectivaDeGenero.Nombre}}
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </div>  
      </div> 
      <!-- <div v-if="!AccionesMostrar.consulta" class="form-group" id="fechaDeSentencia_div">
        <h6 for="fechaDeSentencia">Fecha de sentencia</h6>
        <input type="date" id="fechaDeSentencia" v-model="fechaDeSentencia" @change="A_SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia(fechaDeSentencia)" class="form-control" />
      </div> -->
    </div>
    <hr class="mt-2" />
    <div id="RealizarFiltrosBusqueda_div" class="d-flex row">
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7 pb-2 text-left">
          <button  v-if="!AccionesMostrar.altaLaborales" class="btn btn-primary overwrapDeBotones p-2" @click="limpiarFiltros();ejecutalimpiarTablaResultados();"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Búsqueda</button>
          <button  v-if="AccionesMostrar.altaLaborales" class="btn btn-primary overwrapDeBotones p-2" @click="limpiarFiltros();ejecutalimpiarTablaResultados();"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Formulario</button>
      </div> 
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 pb-1 text-right">
          <button v-if="mostrarBuscar && !AccionesMostrar.altaLaborales" class="btn btn-primary overwrapDeBotones mb-1 p-2" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
          <button v-if="mostrarBuscar && AccionesMostrar.altaLaborales" class="btn btn-primary overwrapDeBotones mb-1 p-2" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-share"></i>&nbsp;&nbsp;Siguiente</button>
      </div> 
      
    </div>    
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from "@/../static/js/comun"
  import { mapActions } from 'vuex'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'

  Vue.use(VueMask);

  export default {
    directives: {
        tooltipF
    },
    data() {
      return {
        togglePerspectivaRender: 1,
        todasLasSentenciasMarcadasComoPerspectivaDeGenero: false,
        textoTodoPerspectivaDeGenero: "Seleccionar todas las sentencias con perspectiva de género",
        mostrarFiltradoPerspectivaDeGenero: false,
        textoFiltrarPerspectivaDeGenero: "Seleccionar sentencias con filtro específico de perspectiva de género",
        prueba: 0,
        enumeraciones,
        consecutivo: "",
        anio:"",
        personaANotificar: '',
        numeroExtra: '',
        folioSentencia: null,
        numeroRomano: null,  
        numeroCarpeta: null,      
        fechaDeDictado: moment().format('YYYY-MM-DD'),
        fechaDeSentencia: moment().format('YYYY-MM-DD'),
        fechaInicial: moment().subtract(5, 'days').format('YYYY-MM-DD'),
        fechaFinal: moment().format('YYYY-MM-DD'),
        fechaDeDictadoInicial: null,//moment().subtract(5, 'days').format('YYYY-MM-DD'),
        fechaDeDictadoFinal: null,
        conPerspectivaDeGenero: false,
        mostrarNumeroExtra: false,
        mostrarDelito: false,
        mostrarJuicio: false,  
        mostrarTramite: false,      
        parametros_PartidoJudicial: {
          key: "",
          partidoJudicialId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Materia: {
          key: "",
          materiaId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Delito: {
          key: "",
          delitoId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false,
        },
        parametros_Juicio: {
          key: "",
          juicioId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false
        },
        parametros_Tramite: {
          key: "",
          tramiteId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false
        },
        parametros_Area: {
          key: "",
          areaId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_TipoResolucion: {
          key: "",
          tipoResolucionId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Consecutivo: {
          key: "",
          parametros: {},
          esInformativo: false
        },               
        mostrarBuscar: true,
        esAreaDeEjecucion: false,
        baseDeDatosId: null,
        mostrarCampoNumCarpeta: false,
        folioAcuerdo: null,
        clasificacionYCaracteristicasPerspectivaDeGenero: null
      }
    },
    components: {
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C003TiposResoluciones: catalogos.SICSEN.C003TiposResoluciones,
      C008Delitos: catalogos.PJ.C008Delitos,
      C042Juicios: catalogos.PJ.C042Juicios,
      C046Tramites: catalogos.PJ.C046Tramites
    },
    props: {
      tituloDeBusqueda: String,
      catalogos: Array,
      elementosAOmitir: Object,
      elementosAConservar: Object,
      ejecutaLaFuncion: Function,
      ejecutalimpiarTablaResultados: Function,
      filtrosEstablecidos: Object,
      buscar: true,
      accionCancelar: {
        default: null,
        type: Object
      },
      AccionesMostrar:{            
        administracion: false,
        consulta: false,
        altaLaborales: false            
      },
      area: null,
      esOralidad: false
    },
    mounted() { 
      if (this.filtrosEstablecidos != undefined) //Agregar validación si hay valore establecidos para los filtros
         this.cargarFiltrosEstablecidos();
      
      if(this.buscar != undefined)
        this.mostrarBuscar = this.buscar;
      
      if(this.elementosAOmitir){
        if(this.elementosAOmitir.areas && this.elementosAOmitir.areas.length > 0){
          this.parametros_Area.parametros.elementosAOmitir = this.elementosAOmitir.areas;
          this.parametros_Area.key = "elementosOmitir_" + this.elementosAOmitir.areas.length;
        }
        if(this.elementosAOmitir.materias && this.elementosAOmitir.materias.length > 0){
          this.parametros_Materia.parametros.elementosAOmitir = this.elementosAOmitir.materias;
          this.parametros_Materia.key = "elementosOmitir_" + this.elementosAOmitir.materias.length;
        }
      }     

      
      /*if(this.AccionesMostrar.consulta){        
          this.fechaDeDictado = "";    
      } */
      this.parametros_Area.parametros.SistemaId = 31;   
      this.parametros_Area.parametros.conOrdenamientoPorSistema = true; 
    },
    beforeMount()
    {
      if(this.area != undefined && this.area != null)
      {
        this.parametros_PartidoJudicial.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.AreaId = this.area.AreaId;
        this.parametros_Materia.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.conInactivos = true;
      }
      else{
        this.parametros_TipoDocumento.parametros.elementosAConservar = [1,2,10,16,23,24];
        this.obtenerFiltroParaPerspectivaDeGeneroAPI();
      }

      if(this.elementosAConservar){        
        if(this.elementosAConservar.areas && this.elementosAConservar.areas.length > 0){
          this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
          this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
        }
      }
      this.fechaDeDictado = ""; 
    },
    created() {
      this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);
      this.$store.dispatch('A_Comun_FechaInicial', this.fechaInicial);
      this.$store.dispatch('A_Comun_FechaFinal', this.fechaFinal);
      this.$store.dispatch('A_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado', this.fechaDeDictado);
      this.$store.dispatch('A_SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia', this.fechaDeSentencia);
      this.$store.dispatch('A_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia', this.folioSentencia);                 
    },
    methods: {    
      /**
       * Método encargado de limpiar los sublistado de una clasificación de característica de género.
       */
      limpiarSublistado:function(clasificacionListado, indexClasificacion)
      {
        if(!clasificacionListado.Activo)
        {
          for (var j in clasificacionListado.SentenciaCaracteristicasPerspectivaDeGenero) {
            this.clasificacionYCaracteristicasPerspectivaDeGenero[indexClasificacion].SentenciaCaracteristicasPerspectivaDeGenero[j].Activo = false;
          }
        }
      },
      /**
       * Método encargado de limpiar listado de perspectivas de género.
       */
      limpiarListadoPerspectiva:function()
      {
        for (var clasificacionIndice in this.clasificacionYCaracteristicasPerspectivaDeGenero) {
          this.clasificacionYCaracteristicasPerspectivaDeGenero[clasificacionIndice].Activo = false;
          for (var caracteristicaIndice in this.clasificacionYCaracteristicasPerspectivaDeGenero[clasificacionIndice].SentenciaCaracteristicasPerspectivaDeGenero) {
            this.clasificacionYCaracteristicasPerspectivaDeGenero[clasificacionIndice].SentenciaCaracteristicasPerspectivaDeGenero[caracteristicaIndice].Activo = false;
          }
        }
      },  
      /**
       * Método encargado de limpiar los filtros de los combos del formulario.
       */
      limpiarFiltros: function(){
        if(this.area == undefined && this.area == null)
        {
          this.parametros_PartidoJudicial.partidoJudicialId = -1;
          this.parametros_PartidoJudicial.parametros.PartidoJudicialId = -1;
          this.parametros_PartidoJudicial.parametros.AreaId = -1;
          this.parametros_PartidoJudicial.parametros.MateriaId = -1;
          $("#filtroDeBusqueda_PartidoJudicial").removeAttr('disabled');        
          this.parametros_PartidoJudicial.key += 1;      

          this.parametros_Materia.materiaId = -1;
          this.parametros_Materia.parametros.PartidoJudicialId = -1;
          this.parametros_Materia.parametros.AreaId = -1;
          this.parametros_Materia.parametros.MateriaId = -1;
          $("#filtroDeBusqueda_Materia").removeAttr('disabled');        
          this.parametros_Materia.key += 1;

          this.parametros_Area.areaId = -1;  
          this.parametros_Area.parametros.PartidoJudicialId = -1;
          this.parametros_Area.parametros.AreaId = -1;
          this.parametros_Area.parametros.MateriaId = -1;
          $("#filtroDeBusqueda_Area").removeAttr('disabled');        
          this.parametros_Area.key += 1;

          this.parametros_TipoDocumento.parametros.PartidoJudicialId = -1;
          this.parametros_TipoDocumento.parametros.AreaId = -1;
          this.parametros_TipoDocumento.parametros.MateriaId = -1;   

          this.parametros_TipoDocumento.parametros.elementosAConservar = [1,2,10,16,23,24];
          this.baseDeDatosId = null;
        } 

        this.parametros_TipoDocumento.tipoDocumentoId = -1;             
        this.parametros_TipoDocumento.key += 1;
        $("#filtroDeBusqueda_TipoDocumento").removeAttr('disabled');       

        this.parametros_TipoResolucion.tipoResolucionId = -1;              
        this.parametros_TipoResolucion.key += 1;

        this.parametros_Delito.delitoId = -1;
        this.parametros_Delito.key += 1; 
        if(this.area == undefined && this.area == null)
          this.mostrarDelito = false;
          
        this.parametros_Juicio.juicioId = -1;
        this.parametros_Juicio.key += 1; 
        if(this.area == undefined && this.area == null)
          this.mostrarJuicio = false;

        this.parametros_Tramite.tramiteId = -1;
        this.parametros_Tramite.key += 1; 
        this.mostrarTramite = false; 

        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.anio = "";
        this.consecutivo = null;        
        this.folioSentencia = null;        
        this.fechaDeDictado = "";
        this.numeroCarpeta = null;
        this.folioAcuerdo = null;
        this.fechaDeDictadoInicial = null;
        this.fechaDeDictadoFinal=null;
        this.conPerspectivaDeGenero = false;
        if(this.clasificacionYCaracteristicasPerspectivaDeGenero)
        {
          this.mostrarFiltradoPerspectivaDeGenero = false; 
          this.todasLasSentenciasMarcadasComoPerspectivaDeGenero = false;
          this.limpiarListadoPerspectiva();
          this.togglePerspectivaRender ++;
        }
        /* 
        if(this.AccionesMostrar.consulta){          
          this.fechaDeDictado = "";
        }else{
          this.fechaDeDictado = moment().format('YYYY-MM-DD');
        }*/
        this.esAreaDeEjecucion = false;
        this.fechaDeSentencia = moment().format('YYYY-MM-DD');             
      },
      /**
       * Método encargado de cargar los filtros de los combos del formulario.
       */
      cargarFiltrosEstablecidos: function(){    
        if(this.filtrosEstablecidos.MateriaId != undefined){
          this.parametros_Materia.materiaId = this.filtrosEstablecidos.MateriaId;                              
          this.parametros_Materia.key = "MateriaEditar_" + this.filtrosEstablecidos.MateriaId;          
        }

        if(this.filtrosEstablecidos.AreaId != undefined){
          this.parametros_Area.areaId = this.filtrosEstablecidos.AreaId;                              
          this.parametros_Area.key = "AreaEditar_" + this.filtrosEstablecidos.AreaId;          
        }
         
        if(this.filtrosEstablecidos.TipoDocumentoId != undefined){
          this.parametros_TipoDocumento.tipoDocumentoId =this.filtrosEstablecidos.TipoDocumentoId;
          this.parametros_TipoDocumento.key = "TipoDocumentoEditar_" + this.filtrosEstablecidos.TipoDocumentoId;         
        }

        if(this.filtrosEstablecidos.TipoResolucionId != undefined){
          this.parametros_TipoResolucion.tipoResolucionId =this.filtrosEstablecidos.TipoResolucionId;
          this.parametros_TipoResolucion.key = "TipoResolucionEditar_" + this.filtrosEstablecidos.TipoResolucionId;         
        }

        if(this.filtrosEstablecidos.Consecutivo != undefined){
          this.consecutivo = this.filtrosEstablecidos.Consecutivo;
          this.$store.dispatch("A_Comun_Consecutivo", this.consecutivo);
        }

        if(this.filtrosEstablecidos.NumeroExtra != undefined && 
        (this.parametros_TipoDocumento.tipoDocumentoId == 2 || this.parametros_TipoDocumento.tipoDocumentoId == 10))
        {
          this.numeroExtra = this.filtrosEstablecidos.NumeroExtra; 
          this.mostrarNumeroExtra = true;   
          this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);          
        }

        if(this.filtrosEstablecidos.NumeroRomano != undefined && this.filtrosEstablecidos.AreaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
        {
          this.esAreaDeEjecucion = true;
          this.numeroRomano = this.filtrosEstablecidos.NumeroRomano;
        }
      },
      /**
       * Método encargado de actualizar/cambiar el campo del Consecutivo.
       * @param {event.target} datos [datos: nuevo valor del Consecutivo]
       */
      cambioDeConsecutivo(datos) {
        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      /**
       * Método encargado de actualizar/cambiar el campo Partido Judicial
       * @param {event.target} datos [datos: nuevo valor del Partido Judicial]
       */
      cambioDePartidoJudicialEvento(datos) {
        this.cambioDePartidoJudicial(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id Partido Judicial
       * @param {int} id [id: identificador del Partido Judicial]
       */
      cambioDePartidoJudicial(id) {
        this.parametros_PartidoJudicial.partidoJudicialId = id;
        //Actualizo area
        this.parametros_Area.parametros.PartidoJudicialId = id;
        if (this.parametros_Area.areaId <= 0 || this.parametros_PartidoJudicial.partidoJudicialId <= 0)
          this.parametros_Area.key = "PartidoJudicial_" + id;

        //Deshabilitar select de partido judicial
        if(this.parametros_PartidoJudicial.partidoJudicialId > 0 && (this.AccionesMostrar.administracion || this.AccionesMostrar.altaLaborales) && !this.esOralidad)
            $("#filtroDeBusqueda_PartidoJudicial").attr('disabled','disabled');
      },
      /**
       * Método encargado de actualizar/cambiar el campo Delito
       * @param {event.target} datos [datos: nuevo valor del Delito]
       */
      cambioDeDelitoEvento(datos){
        this.cambioDeDelito(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Delito
       * @param {int} id [id: identificador del Delito]
       */
      cambioDeDelito(id){
        this.parametros_Delito.delitoId = id; 
      },
      /**
       * Método encargado de actualizar/cambiar el campo Juicio
       * @param {event.target} datos [datos: nuevo valor del Juicio]
       */
      cambioDeJuicioEvento(datos){
        this.cambioDeJuicio(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Juicio
       * @param {int} id [id: identificador del Juicio]
       */
      cambioDeJuicio(id){
        this.parametros_Juicio.juicioId = id;
        this.parametros_Tramite.parametros.JuicioId = id;
        this.parametros_Tramite.tramiteId = -1;
        this.parametros_Tramite.key += 1; 
        this.mostrarTramite = true;
      },
      /**
       * Método encargado de actualizar/cambiar el campo Tramite
       * @param {event.target} datos [datos: nuevo valor del Tramite]
       */
      cambioDeTramiteEvento(datos){
        this.cambioDeTramite(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Tramite
       * @param {int} id [id: identificador del Tramite]
       */
      cambioDeTramite(id){
        this.parametros_Tramite.tramiteId = id;
      },
      /**
       * Método encargado de actualizar/cambiar el campo Materia
       * @param {event.target} datos [datos: nuevo valor del Materia]
       */
      cambioDeMateriaEvento(datos) {
        this.cambioDeMateria(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Materia
       * @param {int} id [id: identificador del Materia]
       */
      cambioDeMateria(id) {
        this.parametros_Materia.materiaId = id;
        if(id == 6 || id == 9){
          this.mostrarDelito = true;
          this.mostrarJuicio = false;          
          this.parametros_Juicio.juicioId = -1;
          this.parametros_Juicio.key += 1;           
        }
        else if (id == -1){
          this.mostrarJuicio = false; 
          this.mostrarDelito = false;
          this.parametros_Juicio.juicioId = -1;
          this.parametros_Juicio.key += 1;
          this.parametros_Delito.delitoId = -1;
          this.parametros_Delito.key += 1; 
        }
        else{
          this.mostrarJuicio = true;          
          this.mostrarDelito = false;
          if(id == 2 || id == 3)
          {
            this.parametros_Juicio.parametros.Naturaleza = 'CIV';
            this.parametros_Juicio.parametros.MateriaId = null;
          }
          else
          {
            this.parametros_Juicio.parametros.Naturaleza = null;
            this.parametros_Juicio.parametros.MateriaId = id;
          }
          this.parametros_Juicio.key += 1;
          this.parametros_Delito.delitoId = -1;
          this.parametros_Delito.key += 1; 
        }
        //Actualizo area
        this.parametros_Area.parametros.MateriaId = id;
        if (this.parametros_Area.areaId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_Area.key = "Materia_" + id;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.MateriaId = id;
        if (this.parametros_TipoDocumento.tipoDocumentoId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_TipoDocumento.key = "Materia_" + id;

        //Deshabilitar select de materia
        /*if(this.parametros_Materia.materiaId > 0)
          $("#filtroDeBusqueda_Materia").attr('disabled','disabled');*/

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 &&
           this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0)
            this.obtenerFiltradoTipoDeDocumentosAPI();

        //this.$emit("cambiarTipoMateria",datos);
      },
      /**
       * Método encargado de actualizar/cambiar el campo Area
       * @param {event.target} datos [datos: nuevo valor del Area]
       */
      cambioDeAreaEvento: function(datos) {
        this.cambioDeArea(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Area
       * @param {int} id [id: identificador del Area]
       */
      cambioDeArea: function(id) {
        this.parametros_Area.areaId = id;

        //Actualizo partido
        this.parametros_PartidoJudicial.parametros.AreaId = id;
        if (this.parametros_PartidoJudicial.partidoJudicialId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_PartidoJudicial.key = "Area_" + id;

        //Actualizo materia
        this.parametros_Materia.parametros.AreaId = id;
        if (this.parametros_Materia.materiaId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_Materia.key = "Area_" + id;

        if(this.parametros_Area.areaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
          this.esAreaDeEjecucion = true;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.AreaId = id;
        if(this.parametros_TipoDocumento.tipoDocumentoId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_TipoDocumento.key = "Area_" + id;

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 &&
           this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0)
            this.obtenerFiltradoTipoDeDocumentosAPI();

        //Deshabilitar select de area
        if(this.parametros_Area.areaId > 0 && (this.AccionesMostrar.administracion || this.AccionesMostrar.altaLaborales) && !this.esOralidad)
          $("#filtroDeBusqueda_Area").attr('disabled','disabled');

        //this.$emit("cambioDeArea",datos);

      },
      /**
       * Método encargado de actualizar/cambiar el campo Tipo de Resolucion
       * @param {event.target} datos [datos: nuevo valor del Tipo de Resolucion]
       */
      cambioDeTipoDeResolucion(datos) {
        this.parametros_TipoResolucion.tipoResolucionId = parseInt(datos.target.value);
      },
      /**
       * Método encargado de actualizar/cambiar el campo Tipo de Documento
       * @param {event.target} datos [datos: nuevo valor del Tipo de Documento]
       */
      cambioDeTipoDeDocumento(datos) {
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        //Actualizo materia
        this.parametros_Materia.parametros.TipoDocumentoId = parseInt(datos.target.value);
        if (this.parametros_Materia.materiaId <= 0 || this.parametros_TipoDocumento.tipoDocumentoId <= 0)
          this.parametros_Materia.key = "TipoDocumento_" + datos.target.value;

        //Mostramos número extra de consecutivo si es Tercería o Incidente.
        if(this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Incidente)
          this.mostrarNumeroExtra = true;
        else
          this.mostrarNumeroExtra = false;

        this.mostrarCampoNumCarpeta = (this.parametros_TipoDocumento.tipoDocumentoId == 27 && this.baseDeDatosId == 3);

        //this.$emit('cambioTipoDeDocumento',datos);

      }, 
      /** 
       * Método encargado de llamar API para obtener id's de los tipos de documentos disponibles dependiendo de la base de datos.
       */
      obtenerFiltradoTipoDeDocumentosAPI()
      {
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          MateriaId: this.parametros_Materia.materiaId,
          AreaId: this.parametros_Area.areaId,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            api.conexion + api.SICSEN.sistema.administracion.sentencias.ObtenerTiposDeDocumentosIdYDBId, 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) 
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else 
            {
              this.parametros_TipoDocumento.parametros.elementosAConservar = respuesta.data.TiposDeDocumentosIds;
              //console.log(this.parametros_TipoDocumento);
              this.baseDeDatosId = respuesta.data.BaseDeDatosId;
              this.parametros_TipoDocumento.key = "elementosAConservar_" + respuesta.data.TiposDeDocumentosIds.length;
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      /** 
       * Método encargado de llamar API para obtener la clasificación y características de perspectiva de género.
       */
      obtenerFiltroParaPerspectivaDeGeneroAPI()
      {
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            api.conexion + api.SICSEN.sistema.consulta.consultaPublicaSentencias.ObtenerFiltroParaPerspectivaDeGenero, 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) 
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else 
            {
              this.clasificacionYCaracteristicasPerspectivaDeGenero = respuesta.data.ClasificacionYCaracteristicasPerspectivaDeGenero;
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      /**
       * Método encargado de actualizar/cambiar el campo Numero Extra
       * @param {event.target} datos [datos: nuevo valor del Numero Extra]
       */
      cambioDeNumeroExtra(datos) {
        this.$store.dispatch("A_Comun_NumeroExtra", datos.target.value);
      },
      /**
       * Método encargado de actualizar/cambiar el campo Folio Sentencia
       * @param {event.target} datos [datos: nuevo valor del Folio Sentencia]
       */
      cambioFolioSentencia(datos) {
        this.$store.dispatch("A_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia", datos.target.value);
      },
      ...mapActions([
        'A_Comun_FechaInicial',
        'A_Comun_FechaFinal',
        'A_Comun_Fecha',
        'A_Comun_Consecutivo',
        'A_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado',
        'A_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia'
      ])
    }
  }
</script>
<style scoped>
  #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
  }
  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }
  ul { 
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICSEN/Comun/FiltroDeBusqueda.vue